import styled from 'styled-components';
import { flexGap } from 'untils/polyfill/flex';

const Container = styled.div`
  width: var(--home-section-width);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: var(--home-section-top-padding) 0;
  ${flexGap('16px')}
`;

const DescBox = styled.div`
  width: 50%;
  height: 376px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  ${flexGap('20px')}
`;

const Title = styled.h2`
  font-weight: 600;
  font-size: 40px;
  margin: 0;
  line-height: normal;
`;

const Footer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  ${flexGap('24px')}
`;

const Desc = styled.div`
  display: flex;
  flex-direction: column;
  ${flexGap('16px')}
  font-weight: 400;
  font-size: 16px;
  line-height: 1.3;
  color: #424748;
`;

const Link = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 180px;
  height: 41px;
  background: #fff;
  color: #424748;
  cursor: pointer;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  &:hover {
    color: #050a30;
  }
`;

const ToJetCard = styled(Link)`
  background: #1f68db;
  color: #fff;
  &:hover {
    color: #fff;
  }
`;

const Cards = styled.div`
  width: fit-content;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
`;

const Card = styled.div`
  width: 278px;
  height: 180px;
  max-width: 278px;
  display: flex;
  justify-content: center;
  align-items: center;
  ${flexGap('8px')}
  background: #f4f6fc;
  border-radius: 2px;
  padding: 0 16px;
  flex-direction: column;
  text-align: center;
`;

const CardImg = styled.img`
  width: 60px;
  height: 60px;
`;

const CardText = styled.span`
  font-weight: 600;
  font-size: 20px;
  text-wrap: nowrap;
`;

const CardDesc = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: 1.3;
`;

const CardKinds = [
  {
    img: '/imgs/svg/home/calendar.svg',
    alt: 'calendar',
    title: 'No Blackout Dates',
    desc: 'Fly whenever you desire, with guaranteed availability',
  },
  {
    img: '/imgs/svg/home/no-fees.svg',
    alt: 'no fees',
    title: 'No Monthly Fees',
    desc: 'Private jet access without the recurring charges.',
  },
  {
    img: '/imgs/svg/home/hourly-rates.svg',
    alt: 'fixed hourly rates',
    title: 'Fixed Hourly Rates',
    desc: 'Predictable costs for seamless budgeting.',
  },
  {
    img: '/imgs/svg/home/globe.svg',
    alt: 'across the globe',
    title: 'Domestic and International',
    desc: 'Reach destinations worldwide with ease.',
  },
];

const PreferredJetCard = () => {
  return (
    <Container>
      <DescBox>
        <Title>
          Airacer Preferred
          <br /> Jet Card
        </Title>
        <Footer>
          <Desc>
            <p>
              With the Airacer Preferred Jet Card, you can prepay for flight hours in
              <br /> blocks of 10, 20, 30, 40, or 50 hours, so you’re always ready to fly.
            </p>
            <p>
              Our end-to-end travel solutions cover everything from black car service
              <br /> and VIP catering to meticulous itinerary planning for a seamless journey.
            </p>
          </Desc>
          <ToJetCard href="/jet-card-membership">Get a Jet Card</ToJetCard>
        </Footer>
      </DescBox>
      <Cards>
        {CardKinds.map((item, index) => (
          <Card key={index}>
            <CardImg src={item.img} alt={item.alt} />
            <CardText>{item.title}</CardText>
            <CardDesc>{item.desc}</CardDesc>
          </Card>
        ))}
      </Cards>
    </Container>
  );
};

export default PreferredJetCard;
